import { useQuery } from '@tanstack/react-query';
import React from 'react';
import type { AssignmentExpenseList } from '../../../../../js/api';
import { AssignmentsService } from '../../../../../js/api';
import { ActivityLog } from '../../../components/activity-log';
import { Dialog, DialogBody, DialogCloseButton, DialogTitle } from '../../../components/dialog';
import type { ActivityHistory } from '../../../utils/activity-types';
import { ASSIGNMENT_EXPENSE_CHANGE_HISTORY_QUERY_KEY } from './queryKeys';

export const ExpenseHistoryModal: React.FC<{
  open: boolean;
  onClose: () => void;
  expense?: AssignmentExpenseList;
}> = ({ open, onClose, expense }) => {
  const expenseId = expense?.id;

  const { data: changeHistory } = useQuery({
    queryKey: [ASSIGNMENT_EXPENSE_CHANGE_HISTORY_QUERY_KEY, expenseId],
    queryFn: () =>
      AssignmentsService.assignmentsAssignmentExpenseChangeHistoryRetrieve({
        id: expenseId!,
        sort: 'desc',
      }),
    enabled: open && !!expenseId,
  });

  return (
    <Dialog open={open} onClose={onClose} size="2xl">
      <DialogTitle className="tw:flex tw:items-center tw:justify-between">
        <div>
          <div>Expense History</div>
          {expense && (
            <div className="tw:text-sm tw:font-normal tw:text-zinc-500">
              {expense.expense_category.title}
            </div>
          )}
        </div>
        <DialogCloseButton onClick={onClose} />
      </DialogTitle>
      <DialogBody>
        <ActivityLog
          enableCommentsFilter={false}
          enableStatusChangesFilter={false}
          enableUpdatesFilter={true}
          enableEventsFilter={false}
          notes={undefined}
          statusHistory={undefined}
          changeHistory={changeHistory as ActivityHistory[] | undefined}
        />
      </DialogBody>
    </Dialog>
  );
};
